import {
  GAME_VENDORS_FIREKIRIN, GAME_VENDORS_GOLDENDRAGON, GAME_VENDORS_GONEFISH, GAME_VENDORS_JUWA, GAME_VENDORS_ORIONSTARS,
  GAME_VENDORS_PUMA, GAME_VENDORS_ULTRAPANDA, GAME_VENDORS_VBLINK, GAME_VENDORS_DRAGONFURY,
  GAME_VENDORS_VEGASX,
  GAME_VENDORS_VEGASZ, GAME_VENDORS_ULTRATHUNDER, GAME_VENDORS_ROYALTREASURE
} from "../../../config/gameVendors";

export const gameWithAccountAndPassword = [
  GAME_VENDORS_FIREKIRIN,
  GAME_VENDORS_PUMA,
  GAME_VENDORS_JUWA,
  GAME_VENDORS_VBLINK,
  GAME_VENDORS_DRAGONFURY,
  GAME_VENDORS_ULTRATHUNDER,
  GAME_VENDORS_ROYALTREASURE,
  GAME_VENDORS_ULTRAPANDA,
  GAME_VENDORS_VEGASX,
  GAME_VENDORS_VEGASZ,
  GAME_VENDORS_GONEFISH,
  GAME_VENDORS_ORIONSTARS
]

export const gameShowChangingPasswordText = [
  GAME_VENDORS_FIREKIRIN,
  GAME_VENDORS_GOLDENDRAGON,
  GAME_VENDORS_PUMA,
  GAME_VENDORS_JUWA,
  GAME_VENDORS_VBLINK,
  GAME_VENDORS_DRAGONFURY,
  GAME_VENDORS_ULTRATHUNDER,
  GAME_VENDORS_ROYALTREASURE,
  GAME_VENDORS_ULTRAPANDA,
  GAME_VENDORS_VEGASX,
  GAME_VENDORS_VEGASZ,
  GAME_VENDORS_GONEFISH,
  GAME_VENDORS_ORIONSTARS
]
